<template>
  <div class="content-section" v-loading.fullscreen.lock="loading">
    <h2 class="page-title">提现申请</h2>
    <div class="form-row" style="margin-bottom: 10px;">
      <div>
        <el-date-picker
          v-model="value1"
          type="datetimerange"
          @change="changeTime"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间">
        </el-date-picker>
      </div>
      <el-button @click="searchBy" type="primary">查询</el-button>
      <el-button @click="addFun" type="success">申请</el-button>
    </div>
    <div>
      <el-table
        :data="CommissionData"
        height="500"
        border
        style="width: 100%">
        <el-table-column
          prop="F_Id"
          label="申请编号"
          align="center"
          header-align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="F_AmountMoney"
          label="提现金额"
          align="center"
          header-align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="F_Remark"
          label="说明备注"
          align="center"
          header-align="center"
        >
        </el-table-column>
        <el-table-column
          prop="F_AuditStatus"
          label="状态"
          align="center"
          header-align="center"
          width="120"
        >
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.F_AuditStatus == 0" size="medium">未申报</el-tag>
            <el-tag type="primary" v-else-if="scope.row.F_AuditStatus == 1" size="medium">待审核</el-tag>
            <el-tag v-else-if="scope.row.F_AuditStatus == 2" size="medium" type="success">审核通过</el-tag>
            <el-tag v-else-if="scope.row.F_AuditStatus == 3" size="medium" type="danger">审核驳回</el-tag>
            <el-tag v-else-if="scope.row.F_AuditStatus == 4" size="medium" type="success">发票已上传</el-tag>
            <el-tag v-else-if="scope.row.F_AuditStatus == 5" size="medium" type="danger">发票驳回</el-tag>
            <el-tag v-else-if="scope.row.F_AuditStatus == 6" size="medium" type="success">已付款</el-tag>
            <el-tag v-else-if="scope.row.F_AuditStatus == 7" size="medium" type="success">发票通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="F_AuditRemark"
          align="center"
          header-align="center"
          width="120"
          label="审批备注">
        </el-table-column>
        <el-table-column
          prop="F_AuditTime"
          align="center"
          header-align="center"
          width="160"
          label="审批时间">
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          width="120"
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <el-link type="primary" @click="onDisplay(scope.row)">查看</el-link>
            <!--<el-link type="primary" @click="onUpload(scope.row)">上传发票</el-link>-->
            <el-link v-if="scope.row.F_AuditStatus == 2 || scope.row.F_AuditStatus == 5" type="primary" @click="onUpload(scope.row)">上传发票</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="total>0"
        background
        layout="prev, pager, next"
        :page-size="PageSize"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog center title="提现申请" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="apply" label-width="120px">
        <el-form-item label="提现金额">
          <el-input disabled v-model="apply.F_AmountMoney" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="说明">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入"
            v-model="apply.F_Remark">
          </el-input>
        </el-form-item>
      </el-form>
      <div>
        <div style="color: red;font-weight: 600;margin: 10px 0px;">佣金总金额:{{allMoney || 0}}</div>
        <el-table
          :data="applys"
          height="500"
          border
          v-loading="loading1"
          @selection-change="handleSelectionChange"
          style="width: 100%">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="F_ContractId"
            label="编号"
            align="center"
            header-align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="F_ContractName"
            label="名称"
            align="center"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="F_EntryTime"
            align="center"
            header-align="center"
            width="160"
            label="结算时间">
          </el-table-column>
          <el-table-column
            prop="F_Amount"
            align="center"
            header-align="center"
            width="120"
            label="金额">
          </el-table-column>

        </el-table>
        <el-pagination
          v-if="total1>0"
          background
          layout="prev, pager, next"
          @current-change="onCurrentChange1"
          @size-change="onSizeChange1"
          :total="total1">
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="btnloading" type="primary" @click="saveApply">提 交</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>

      </div>
    </el-dialog>
    <el-dialog width="1400px" center title="详情" :visible.sync="dialogFormVisible1" :close-on-click-modal="false">
      <el-form :model="applyData" label-width="120px">
        <el-form-item label="代理名称:">
          {{applyData.F_AgentName}}
        </el-form-item>
        <el-form-item label="提现金额:">
            {{applyData.F_AmountMoney}}
        </el-form-item>
        <el-form-item label="说明备注:">
            {{applyData.F_Remark}}
        </el-form-item>
        <el-form-item label="审批备注:">
          {{applyData.F_AuditRemark}}
        </el-form-item>
      </el-form>
      <div v-if="isUpload" style="color: red;margin: 5px 0px;font-weight: 600">注意:将下面的佣金明细上传完发票信息之后，记得点击最下方的‘提交发票审核’按钮，进行提交,否则将无法审核。</div>
      <div>
        <el-table
          :data="applyMappingDatas"
          height="500"
          border
          style="width: 100%">
          <el-table-column
            prop="F_ContractName"
            label="明细名称"
            align="center"
            header-align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="F_Amount"
            align="center"
            header-align="center"
            width="120"
            label="提现金额">
          </el-table-column>
          <el-table-column
            prop="F_CompanyName"
            label="开票公司"
            align="center"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="F_InvoiceProjectName"
            label="开票项目名称"
            align="center"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="F_CompanyBusNo"
            label="开票税号"
            align="center"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="F_InvoicePoint"
            label="开票点数"
            align="center"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="F_InvoiceMoney"
            label="开票金额"
            align="center"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="F_FileName"
            label="发票名称"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-link type="primary" @click="openIt(scope.row)">{{scope.row.F_FileName}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            v-if="isUpload"
            align="center"
            header-align="center"
            :key="Math.random()"
            width="100"
            label="操作">
            <template slot-scope="scope">
              <el-link type="primary" @click="uploadFun(scope.row)">上传发票</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="isUpload" type="primary" @click="submitInvoice">提交发票审核</el-button>
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog center width="500px" title="上传发票" :visible.sync="dialogFJVisibleLaw" :close-on-click-modal="false">
      <el-form  :model="inForm" label-width="100px">
        <el-form-item label="发票名称:">
          <el-input
            placeholder="发票名称"
            v-model="inForm.F_FileName"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="上传发票:">
          <el-upload :limit="limitLaw" :headers="uploadHeaders" :data="extraParamsLaw" :action="uploadUrl" :class="{ 'hide': hideUpload }"
                     :with-credentials="true" list-type="text" :on-preview="preView" :file-list="fileListLaw" :on-success="handleSuccessLaw" :before-upload="beforeUploadLaw"
                     :on-remove="handleRemoveLaw">
            <span style="color: #409EFF;">选择发票</span>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" plain @click="saveInvoice">保 存</el-button>
        <el-button type="info" plain @click="dialogFJVisibleLaw = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        queryParams: {
          StartTime:'',
          EndTime:''
        },
        url: {
          list: SZH.assets.api + '/Custom/GetPagingWithdrawalApply',
          GetPagingCommissionInfos: SZH.assets.api + '/Custom/GetPagingCommissionInfos',
          SaveAgentWithdrawalApply: SZH.assets.api + '/Custom/SaveAgentWithdrawalApply',
          GetCustomAgentWithdrawalApplyData: SZH.assets.api + '/Custom/GetCustomAgentWithdrawalApplyData',
          GetMyCommissionEntity: SZH.assets.api + '/Custom/GetMyCommissionEntity',
          UploadCustomAgentWithdrawalApplyInvioce: SZH.assets.api + '/Custom/UploadCustomAgentWithdrawalApplyInvioce',
          SumbitCustomAgentWithdrawalApplyInvioce: SZH.assets.api + '/Custom/SumbitCustomAgentWithdrawalApplyInvioce',
        },
        loading: false,
        loading1: false,
        btnloading: false,
        value1:[],
        CommissionData:[],
        applys:[],
        details:[],
        PageIndex:1,
        PageSize:50,
        total:0,
        PageIndex1:1,
        PageSize1:10,
        total1:0,
        apply:{
          F_AmountMoney:null,
          F_Remark:''
        },
        applyMappings:[],
        dialogFormVisible:false,
        dialogFormVisible1:false,
        dialogFJVisibleLaw:false,
        selection:[],
        allMoney:0,
        applyData:{},
        applyMappingDatas:[],
        isUpload:false,
        limitLaw:1,
        fileListLaw:[],
        countLaw:0,
        hideUpload: false,
        inForm:{
          F_Id:'',//获取表单中applyMappingDatas 的F_Id
          F_FileName:'',//发票名称
          F_FileUrl:'',//文件相对路径
        }
      }
    },
    methods: {
      preView(file){
        console.log(file)
        window.open(SZH.assets.image +'/' + file.url);
      },
      openIt(row){
        window.open(SZH.assets.image +'/' + row.F_FileUrl);
      },
      uploadFun(row){
        let self = this;
        self.dialogFJVisibleLaw = true;
        self.inForm.F_Id = row.F_Id;
        self.inForm.F_FileName = '';
        self.inForm.F_FileUrl = '';
        self.fileListLaw = [];

      },
      submitInvoice(){
        let self = this;
        self.loading = true;
        self.$http.post(self.url.SumbitCustomAgentWithdrawalApplyInvioce,{
          keyValue:self.applyData.F_Id
        })
          .then(result => {
            if (result.state == true) {
              self.$message.success('提交发票审核成功!');
              self.dialogFormVisible1 = false;
              self.reload();
            } else {
              self.$message.error(result.message)
            }
            self.loading = false;
          }, () => {
            self.loading = false;
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
      saveInvoice(){
        let self = this;
        if(!self.inForm.F_FileName){
          self.$message.error('请输入发票名称！');
          return
        }
        if(!self.inForm.F_FileUrl){
          self.$message.error('请上传发票！');
          return
        }
        self.loading = true;
        self.$http.post(self.url.UploadCustomAgentWithdrawalApplyInvioce,self.inForm)
          .then(result => {
            if (result.state == true) {
              self.$message.success('发票上传成功!');
              self.dialogFJVisibleLaw = false;
              self.reSearch();
            } else {
              self.$message.error(result.message)
            }
            self.loading = false;
          }, () => {
            self.loading = false;
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
      reSearch(){
        let self = this;
        self.$http.post(self.url.GetCustomAgentWithdrawalApplyData,{
          keyValue:self.applyData.F_Id
        })
          .then(result => {
            if (result.state == true) {
              self.applyData = result.data.applyData;
              self.applyMappingDatas = result.data.applyMappingDatas;
            } else {
            }
          }, () => {
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
      beforeUploadLaw(file){
        const self = this;
        if(self.fileListLaw && self.fileListLaw.length>0){
          self.$message.error('文件只能上传一次！');
          return
        }
        const isPDF = file.type === 'application/pdf';
        const isLt2M = file.size / 1024 / 1024 < 100;
        // if (!isPDF) {
        //   self.$message.error('上传的文件只能是PDF格式!');
        // }else
        if (!isLt2M) {
          self.$message.error('上传的文件大小不能超过 100MB!');
        }

        return isLt2M;
      },
      handleSuccessLaw(response, file, fileList) {
        if (response && response[0].success == true) {
          this.countLaw = fileList.length;
          this.fileListLaw = [];
          this.inForm.F_FileUrl = response[0].FileName;
          let obj = {
            name:'',
            url:''
          };
          obj.name = response[0].File;
          obj.url = response[0].FileName;
          this.fileListLaw.push(obj);
        }else{
          this.$message.error(response[0].message)
        }
      },
      handleRemoveLaw(file, fileList) {
        var self = this;
        self.countLaw = fileList.length;
        self.inForm.F_FileUrl = '';
        self.fileListLaw = [];
      },
      onUpload(row){
        let self = this;
        self.isUpload = true;
        self.dialogFormVisible1 = true;
        self.$http.post(self.url.GetCustomAgentWithdrawalApplyData,{
          keyValue:row.F_Id
        })
          .then(result => {
            if (result.state == true) {
              self.applyData = result.data.applyData;
              self.applyMappingDatas = result.data.applyMappingDatas;
            } else {
            }
          }, () => {
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
      onDisplay(row){
        let self = this;
        self.isUpload = false;
        self.dialogFormVisible1 = true;
        self.$http.post(self.url.GetCustomAgentWithdrawalApplyData,{
          keyValue:row.F_Id
        })
          .then(result => {
            if (result.state == true) {
              self.applyData = result.data.applyData;
              self.applyMappingDatas = result.data.applyMappingDatas;
            } else {
            }
          }, () => {
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
      addFun(){
        let self = this;
        self.dialogFormVisible = true;
        self.apply.F_AmountMoney = '';
        self.apply.F_Remark = '';
        self.getItems();
      },
      saveApply(){
        let self = this;
        if(self.selection && self.selection.length ==0){
          self.$message.error('请选择需要提现的佣金明细');
          return
        }
        if(self.apply.F_AmountMoney<=0){
          self.$message.error('申请金额不能小于0');
          return
        }
        let applyMappings = [];
        self.selection.forEach(item=>{
          let obj = {};
          obj.F_EntryInfoId = item.F_Id;
          applyMappings.push(obj)
        });

        self.btnloading = true;
        self.$http.post(self.url.SaveAgentWithdrawalApply,{
          apply:self.apply,
          applyMappings:applyMappings
        })
          .then(result => {
            if (result.state == true) {
              self.$message.success('提交成功!');
              self.dialogFormVisible = false;
              self.reload()
            } else {
              self.$message.error(result.message)
            }
            self.btnloading = false;
          }, () => {
            self.btnloading = false;
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
      handleSelectionChange(val){
        this.selection = val;
        const total = val.reduce((sum, item) => sum + item.F_Amount, 0);
        this.apply.F_AmountMoney = total;
      },
      searchBy(){
        let self = this;
        self.loadData();
      },
      changeTime(val){
        if(val && val.length>0){
          this.queryParams.StartTime = val[0];
          this.queryParams.EndTime = val[1];
        }
      },
      getFirstDayOfMonth() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}-01 00:00:00`;
      },
      onSizeChange(val) {
        this.PageSize = val;
        this.loadData();
      },
      onCurrentChange(val) {
        this.PageIndex = val;
        this.loadData();
      },
      onSizeChange1(val) {
        this.PageSize1 = val;
        this.getItems();
      },
      onCurrentChange1(val) {
        this.PageIndex1 = val;
        this.getItems();
      },
      getItems(){
        let self = this;
        self.loading1 = true;
        self.$http.post(self.url.GetPagingCommissionInfos,{
          Data:{
            ApplyState:0
          },
          PageIndex:self.PageIndex1,
          PageSize:self.PageSize1
        })
          .then(result => {
            if (result.state == true && result.data && result.data.Data && result.data.Data.length>0) {
              self.applys = result.data.Data;
              self.allMoney = result.data.SummerData.F_Amount;
              self.total1 = result.data.TotalCount;
            } else {
              self.allMoney = 0;
              self.applys = [];
              self.total1 = 0;
            }
            self.loading1 = false;
          }, () => {
            self.loading1 = false;
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
      reload(){
        this.CommissionData = [];
        this.PageIndex = 1;
        this.loadData();
      },
      loadData(){
        let self = this;
        self.loading = true;
        self.$http.post(self.url.list,{
          Data:self.queryParams,
          PageIndex:self.PageIndex,
          PageSize:self.PageSize
        })
          .then(result => {
            if (result.state == true && result.data && result.data.Data && result.data.Data.length>0) {
              self.CommissionData = result.data.Data;
              self.total = result.data.TotalCount;
            } else {
              self.CommissionData = [];
              self.total = 0;
            }
            self.loading = false;
          }, () => {
            self.loading = false;
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
    },
    computed: {
      uploadHeaders() {
        var token = localStorage.ms_token;
        return {Authorization: 'Bearer ' + token};
      },
      extraParamsLaw(){
        return {
          upLoadType:'2',
          upLoadFolder:'',
          ImageType:'Invoice',
          code:''
        }
      },
      uploadUrl() {
        return SZH.assets.api + '/File/PostFile'
      },
    },
    components: {
    },
    mounted() {
      this.loadData();
    }
  }
</script>

<style scoped>
  .form-row {
    display: flex;
    gap: 20px;
  }

  .form-row .form-group {
    flex: 1;
  }
  .form-group {
    margin-bottom: 20px;
  }

  .form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #000000;
  }

  .form-control {
    width: 100%;
    padding: 12px 15px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 16px;
    transition: border-color 0.3s;
  }

  .form-control:focus {
    border-color: #1a3a6c;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/Me/CashRequest/CashRequest.vue